export default __webpack_public_path__ + "static/logo-8fd4513169971cbd19dfa9d8be368165.png";